import React from 'react';
import cn from 'classnames';
import styles from './index.module.less'
import type { IReplaceText } from 'base/interfaces/common';

type IProps = {
    data?: IReplaceText | string;
    className?: string;
}

const replaceHandle = (data?: IReplaceText) => {
    const {
        tipsText,
        boldTexts = []
    } = data || {}

    let text = tipsText

    for (let i = 0; i < boldTexts.length; i++) {
        const target = boldTexts[i]
        const reg = `{{${target}}}`
        text = text?.replaceAll(reg, `<span>${target}</span>`) || ''
    }
    return text || ''
}

const ReplaceAllText: React.FC<IProps> = (props) => {

    const {
        data: replace,
        className
    } = props

    return (
        <div className={cn(className, 'replace-all-text')}>
            <div className={cn(styles['text'], 'text')}
                 dangerouslySetInnerHTML={{
                     __html: typeof replace === 'string' ? replace : replaceHandle(replace)
                 }}
            />
        </div>
    );
};

export default React.memo(ReplaceAllText)